// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail_fbi9H","hiddenTitle":"detail_hiddenTitle_3ocEn","title":"detail_title_2z9OL","content":"detail_content_2eGnz"};